import { Box, ListItemText } from "@mui/material";
import moment from "moment";

function Message({ isSender = true, message }) {

  return (
    <Box
      sx={{
        gap: 1,
        display: "flex",
        flexDirection: isSender ? "row-reverse" : "row"
      }}
    >
      <ListItemText
        sx={{
          m: 0,
          p: 1,
          maxWidth: "60%",
          borderRadius: "5px",
          bgcolor: isSender ? "blue.100" : "white",
        }}
        primary={message?.text}
        secondary={moment(message?.createdAt).format("DD-MM hh:mm A")}
        slotProps={{
          primary: { style: { fontSize: 15, lineHeight: 1.2 } },
          secondary: { style: { fontSize: 13, lineHeight: 1.2, marginTop: 5 } },
        }}
      />
    </Box>
  )
}

export default Message